export default [
    {
        path: '/coupons',
        name: 'Coupons',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Coupons',
        },
        components: {
            default: () => import('@views/coupons/CouponsIndex.vue'),
        },
    },
    {
        path: '/coupons/create',
        name: 'CouponsCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create a new coupon',
        },
        components: {
            default: () => import('@views/coupons/CouponCreate.vue'),
        },
    },
    {
        path: '/coupons/:id/edit',
        name: 'CouponsEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Coupon edit',
        },
        components: {
            default: () => import('@views/coupons/CouponEdit.vue'),
        },
    },
];
